"use strict";

import Dropdown from 'bootstrap/js/dist/dropdown';

export function init() {
    let dropdownTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'))
    let dropdownList = dropdownTriggerList.map(function (dropdownTriggerEl) {
        return new Dropdown(dropdownTriggerEl);
    });
}